import { RequestBuilder, authorizedPipe } from 'services/net'
import { LEGACY_URL } from 'config'

export const ENDPOINT_REFRESH_INSIGHTS = `${LEGACY_URL}/v3/posts/refresh_insights`

export const V1 = Object.freeze({
  refreshInsights: function () {
    return function (ppid: string) {
      const builder = new RequestBuilder(ENDPOINT_REFRESH_INSIGHTS).asPost().expectJSON().asFormUrlEncoded()

      return authorizedPipe<any>(
        builder
          .body({ pp_page_id: ppid })
          .build()
      )
    }
  }()
})
